import { Box, GridCell, GridRow, LoaderOverlay, pxToRem } from '@pocketlaw/tetris';
import { Pagination } from 'shared/domains/common-ui';
import { Contact } from './Contact';
import { ErrorState } from './ErrorState';
import { NoData } from './NoData';
import { SearchField } from './SearchField';
import { useContactLibraryState } from './useContactLibraryState';
import { useGetContacts } from './useGetContacts';
import { StyledBox } from './styled';
export function ContactLibrary(props) {
    const { onSelect } = props;
    const { state, setSearchKey, setSearchValue, resetState, setOffset, setVisibility } = useContactLibraryState();
    const { limit, offset, searchKey, searchValue, visibility } = state;
    const { data, loading, error, refetch } = useGetContacts({
        searchKey,
        searchValue,
        limit,
        offset,
        visibility,
    });
    const { items, totalCount } = data || {};
    const hasData = !error && Boolean(items === null || items === void 0 ? void 0 : items.length);
    const missingItems = Array.from({ length: limit - ((items === null || items === void 0 ? void 0 : items.length) || 0) }).map((_, i) => i);
    return (<Box flexDirection="column" gap="lg">
      <GridRow style={{ alignItems: 'center' }}>
        <GridCell width={{ base: 12, md: 9 }}>
          <SearchField loading={loading} searchKey={searchKey} searchValue={searchValue} resetState={resetState} setSearchKey={setSearchKey} setSearchValue={setSearchValue} setVisibility={setVisibility} visibility={visibility}/>
        </GridCell>

        <GridCell width={{ base: 12, md: 3 }}>
          <Box justifyContent="flex-end">
            <Pagination disabled={loading} limit={limit} count={totalCount || 0} offset={offset} setOffset={setOffset}/>
          </Box>
        </GridCell>
      </GridRow>

      <LoaderOverlay enabled={loading}>
        <GridRow style={{ gridTemplateRows: `repeat(3, ${pxToRem(130)})` }}>
          {hasData && (items === null || items === void 0 ? void 0 : items.map((contact) => <Contact key={contact.id} from={contact} onSelect={onSelect}/>))}

          {hasData &&
            missingItems.map((id) => (<GridCell key={id} width={{ base: 12, md: 6 }}>
                <StyledBox style={{ visibility: 'hidden' }}>&nbsp;</StyledBox>
              </GridCell>))}

          {error && <ErrorState onRefetch={() => refetch({ where: { [searchKey]: { contains: searchValue } } })}/>}

          {!loading && !error && !hasData && <NoData reset={resetState}/>}
        </GridRow>
      </LoaderOverlay>
    </Box>);
}
